import { Trans, type TransProps } from "react-i18next";

/**
 * Unescapeが必要なユーザー入力を翻訳・補間するとき、明示的にshouldUnescapeをtrueにするコンポーネントです
 * Please see 【ADR】i18nにおけるエスケープ対応方針(文字化け防止)【2025-03】
 */
// biome-ignore lint/suspicious/noExplicitAny: <explanation> 型絞りたいけど、調査できてないので一旦ignore
export const UnescapedTrans = (props: TransProps<any>) => {
  return <Trans {...props} shouldUnescape={true} />;
};
